<template>
  <section>
    <h1 class="title">{{$t('users', 'Users')}}</h1>
    <loader :loading="isLoadingUsers" :message="$t('loading-users', 'Loading users...')">
      <data-table
        :data="users"
        :columns="[
          { key: 'username', displayName: $t('username', 'Username'), editable: false, sortable: true },
          { key: 'role', displayName: $t('role', 'Role'), sortable: true, editable: true }
        ]"
        @onEditRow="editUser = $event"
        @onDeleteRow="deleteUser"
      />
    </loader>
    <div v-if="editUser" class="modal is-active">
      <div class="modal-background" @click="editUser = undefined"></div>
      <div class="modal-card">
        <div class="modal-card-head">
          <h1 class="title">{{$t('edit-user', 'Edit user')}}</h1>
        </div>
        <div class="modal-card-body">
          <user-form
            ref="editUserForm"
            :existingUser="editUser"
            @onSubmitUser="updateUser"
          />
        </div>
        <div class="modal-card-foot">
          <div class="field is-grouped">
            <button class="button is-primary" @click="$refs.editUserForm.submitUser()">{{$t('save', 'Save')}}</button>
            <button class="button is-text" @click="editUser = undefined">{{$t('cancel', 'Cancel')}}</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'
import DataTable from '@/components/DataTable'
import UserForm from '@/components/UserForm'
import Loader from '@/components/Loader'
import api from '@/api'

export default {
  name: 'Users',
  components: { DataTable, UserForm, Loader },
  data () {
    return {
      users: [],
      editUser: undefined,
      isLoadingUsers: false
    }
  },
  methods: {
    updateUser (user) {
      api.users
        .update(user.id, user)
        .then(() => {
          const idx = this.users.findIndex(u => u.id === user.id)
          Vue.set(this.users, idx, user)
          this.editUser = undefined
        })
        .catch((err) => {
          const message = this.$t('error-updating-user', {
            replace: { error: err },
            defaultValue: `Error updating user: ${err}`
          })
          this.$notifyError(undefined, message)
        })
    },
    deleteUser (user) {
      api.users
        .delete(user.id)
        .then(() => {
          const idx = this.users.findIndex(u => u.id === user.id)
          Vue.delete(this.users, idx)
        })
        .catch((err) => {
          const message = this.$t('error-deleting-user', {
            replace: { error: err },
            defaultValue: `Error deleting user: ${err}`
          })
          this.$notifyError(undefined, message)
        })
    }
  },
  mounted () {
    this.isLoadingUsers = true

    api.users
      .getAll()
      .then((res) => {
        this.users = Array.from(res.data).map(row => Object.freeze(row))
      })
      .catch((err) => {
        const message = this.$t('error-getting-users', {
          replace: { error: err },
          defaultValue: `Error getting users: ${err}`
        })
        this.$notifyError(undefined, message)
      })
      .finally(() => {
        this.isLoadingUsers = false
      })
  }
}
</script>
